import { Modal } from 'react-bootstrap';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { addCurrentThemeClassToEle } from '@/utils';
import LightGrayCross from "@/assets/icons/lightGrayCross.png";
import { themes } from '@/constants/colors_v2';
import "./style.css"


function GoBackModal(props: any) {
    const { common, profile } = useLocalTranslation();
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (
        <Modal
            show={props.show}
            onHide={() => props.handleClose('close')} centered>
            <div className={`p-[20px] ${addCurrentThemeClassToEle(currentTheme, 'emptyModalIndex')}  ${addCurrentThemeClassToEle(currentTheme, 'goBackModalMain')}`}>

                <Modal.Header className='p-0 border-0 mb-[10px]'>


                    {currentTheme === themes.dark ? (
                        <div className='darkThemetopCloseButtonHelperModelCon'>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                            {profile.addressDetailsSection.notes.n4}
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose('close')}
                                type="button"
                                className='text-[14px]'
                                aria-label="Close">
                                <img src={LightGrayCross} alt='LightGrayCross' className='w-[14px]' />
                            </button>
                        </div>
                    ) : (
                        <>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                            {profile.addressDetailsSection.notes.n4}
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose('close')}
                                type="button"
                                className='btn-close topCloseButtonHelper'
                                aria-label="Close">
                            </button>

                        </>
                    )}



{/* 
                    <Modal.Title className='text-[16px] font-bold'>
                        {profile.addressDetailsSection.notes.n4}
                    </Modal.Title>
                    <button
                        onClick={() => props.handleClose('close')}
                        type="button"
                        className="btn-close text-[14px]" aria-label="Close"></button> */}



                </Modal.Header>

                <Modal.Body className='p-0'>
                    {profile.addressDetailsSection.notes.n5}
                </Modal.Body>


                <div className="text-[14px] flex justify-between mt-6 space-x-4">
                    <button
                        className="watchModel12LeftBtn flex-1 font-medium py-2 rounded-md"
                        onClick={() => props.handleClose('discard')}
                    >
                        {common.statusText.discardBtn}
                    </button>
                    <button
                        style={{
                            cursor: props.isSubmitBtnLoading ? 'not-allowed' : 'pointer',
                            backgroundColor: props.isSubmitBtnLoading ? '#9f9f9f' : '#1573FE'
                        }}
                        className="flex-1 text-white font-medium py-2 rounded-md"
                        onClick={() => props.handleClose('saveAndClose')}
                    >
                        {props.isSubmitBtnLoading ? common.statusText.savingBtn : common.statusText.saveBtn}
                    </button>
                </div>

            </div>
        </Modal>
    );
}

export default GoBackModal;